import type { LocaleType } from '@antv/s2';
import { EN_US } from './en_US';
import { ZH_CN } from './zh_CN';

export const Locale: LocaleType = {
  zh_CN: ZH_CN,
  en_US: EN_US,
};
